<app-pro-select-header></app-pro-select-header>

<div class="container">
    <div class="background-container">
        <div *ngIf="showReadyToMap" class="import-details-container">
            <h1>{{importType}}</h1>
            <h2>{{importYear}} &bull; {{importQuarter}}</h2>

            <span><span style="font-weight: bold;">Uploaded:</span> {{importedDate}} - {{importerName}}</span>

            <br>
            <br>
            
            <button class="btn action-button" (click)="beginDataMapping()">MAP DATA</button>
        </div>
    </div>
</div>